import React from 'react';
import Modal, { ModalProps } from '.';
import Button from '../button';

interface ModalWithButtonsProps extends ModalProps {
	primaryButton: { text: string; function: () => void };
	secondaryButton: { text: string; function: () => void };
}

const ModalWithButtons: React.FC<ModalWithButtonsProps> = ({
	open,
	title,
	children,
	onClose,
	className,
	primaryButton,
	secondaryButton,
}) => {
	return (
		<Modal
			open={open}
			title={title}
			onClose={onClose}
			className={className}
			contentClassName="w-full">
			{children}
			<div className="flex flex-col mt-8">
				<Button onClick={primaryButton.function}>{primaryButton.text}</Button>
				<Button
					onClick={secondaryButton.function}
					className="text-font underline mt-4">
					{secondaryButton.text}
				</Button>
			</div>
		</Modal>
	);
};

export default ModalWithButtons;
